<template>
  <div id="calender" class="calender">
    <div class="ctop">
      <div class="citem">
        <div class="cday" style="color: #44ce18">正常天数</div>
        <div class="cnum" id="cnum4" style="color: #44ce18">{{normalDays}}天</div>
      </div>
      <div class="citem">
        <div class="cday" style="color: #e84848">报警天数</div>
        <div class="cnum" id="cnum3" style="color: #e84848">{{warningDays}}天</div>
      </div>
      <div class="citem">
        <div class="cday" style="color: #acaaab">断电天数
          <div class="iconBtn">
          <span class="down">
                <Icon type="arrow-down-c"  @click="showTable()" v-if="isShowTable" class="showIcon"></Icon>
              </span>
            <span class="up">
                <Icon type="arrow-up-c" @click="showTable()" v-if="!isShowTable" class="showIcon"></Icon>
              </span>
          </div>
        </div>

        <div class="cnum" id="cnum1" style="color: #acaaab">{{errorDays}}天</div>
      </div>
    </div>
    <div id='scheduleBox' v-show="isShowTable" class="boxshaw"></div>
    <div class="cbto">
      <p>监测站点：{{monitorStationName}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userConfig: {},
        isShowTable: true,
        errorDays: "",
        normalDays: "",
        warningDays: "",
        time: "",
        monitorStationId: 0,
        monitorStationName:''
      }
    },
    methods: {
      getInitStation(){
        this.$http.get(this.userConfig.apiName + "/v4/monitorStation/realData")
        .then(response => {
          if(response.data.code == 0){
            let data = response.data.data;
            this.$set(this,'monitorStationId',data.monitorId);
            this.$set(this,'monitorStationName',data.shortName);
            this.getMonth();
          }
        });
      },
      getMonth() {
        let date = new Date();
        let year = date.getFullYear();
        let month = (date.getMonth() + 1) < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        this.$set(this,'time',year + "-" + month);
        this.getData();
      },
      getData() {
        this.$http.get(this.userConfig.apiName + "/v4/mapMonitorStation/calendar", {
          params: {
            monitorStationId: this.monitorStationId,
            month: this.time
          }
        })
        .then(response => {
          if(response.data.code == 0){
            let result = response.data.data;
            this.$set(this,'errorDays',result.errorDays);
            this.$set(this,'normalDays',result.normalDays);
            this.$set(this,'warningDays',result.warningDays);
            let dailyReports = result.dailyReports;
            for(let i = 0;i < dailyReports.length;i++){
              let time = dailyReports[i].time;
              let type = dailyReports[i].type;
              let bgcolor = "";
              switch(type){
                case "errorDays":
                  bgcolor = "#acaaab";
                  break;
                case "normalDays":
                  bgcolor = "#82d746";
                  break;
                case "warningDays":
                  bgcolor = "#e84848";
                  break;
              }
              $(".current-month span[title='" + time + "']").css({"background": bgcolor, "border": "0px", "color": "#fff" });
            }
          }
        });
      },
      showTable() {
        this.$set(this, "isShowTable", !this.isShowTable);
      },
      getTime(y, m, d){
        m = m < 9 ? "0" + m : m;
        this.$set(this,'time',y + "-" + m);
        this.getData();
      }
    },
    mounted() {
      this.$set(this,"userConfig",JSON.parse(window.sessionStorage.getItem("userConfig")));
      if(this.userConfig){
        let $ele = this;
        new Schedule({
          el: "#scheduleBox",
          nextMonthCb: (y, m, d) => {
            this.getTime();
          },
          nextYeayCb: (y, m, d) => {
            this.getTime();
          },
          prevMonthCb: (y, m, d) => {
            this.getTime();
          },
          prevYearCb: (y, m, d) => {
            this.getTime();
          }
        });
        this.getInitStation();
        this.$root.monitorStationHub.$off("monitorStation");
        this.$root.monitorStationHub.$on("monitorStation", (monitorStationId,monitorStationName) => {
          this.$set(this,'monitorStationId',monitorStationId);
          this.$set(this,'monitorStationName',monitorStationName);
          this.getMonth();
        });
      }
    }
  };
</script>

<style lang="less">
  .calender {
    background: #071421;
    opacity:1;
    border-radius: 5px;
    padding: 10px;
    * {
      margin: 0;
      padding: 0;
    }
    ul {
      list-style: none;
    }
    position: fixed;
    left: 0px;
    bottom: 0px;
    z-index: 99;
    .ctop {
      text-align: center;
    }
    .citem {
      border-radius: 5px;
      overflow: hidden;
      display: inline-block;
      width: 100px;
    }
    .cday {
      font-size: 14px;
      padding: 5px 0px;
      border-bottom: 1px solid #04594c;
    }
   .cday .iconBtn{
     position: absolute;
     right: 0;
     top: 0;
    }
    .cnum {
      font-size: 14px;
      padding: 5px 0px 0px;
    }

    #scheduleBox {
      width: 300px;
      margin: 0 auto;
      font-size: 13px;
      color: #fff;
    }
    .schedule-hd {
      display: flex;
      justify-content: space-between;
      padding: 0px 15px 10px;
      font-size: 18px;
    }
    .today {
      flex: 1;
      text-align: center;
      line-height: 40px;
    }
    .ul-box {
      overflow: hidden;
    }
    .week-ul {
      margin-bottom: 5px;
    }
    .week-ul > li {
      color: #fff;
    }
    .ul-box > li {
      float: left;
      width: 14.28%;
      text-align: center;
    }
    .schedule-bd > li {
      border: 1px solid #66c4b5;
      border-radius: 5px;
      overflow: hidden;
      width: calc(14.28% - 6px);
      box-sizing: border-box;
      margin: 3px;
      height: 27px;
      background: transparent !important;
      color: #fff !important;
    }
    .other-month {
      color: #003366;
      border: 0px !important;
      *{
        color: #003366;
      }
    }
    .current-month {
      color: #333333;
    }
    .today-style {
      border-radius: 50%;
      background: #007648;
    }
    .arrow {
      cursor: pointer;
    }
    #prevYear:before {
      content: "<<";
      font-size: 24px;
      font-weight: bold;
    }
    #prevMonth:before {
      content: "<";
      font-size: 22px;
      margin-left: 20px;
    }
    #nextYear:before {
      content: ">>";
      font-size: 24px;
      font-weight: bold;
      margin-left: 20px;
    }
    #nextMonth:before {
      content: ">";
      font-size: 22px;
      margin-left: 5px;
    }
    .dayStyle {
      display: inline-block;
      width: 100%;
      text-align: center;
      line-height: 27px;
      cursor: pointer;
    }
    .before {
      background: #82d746;
      color: #fff;
    }
    .after {
      background: #fff;
      color: #333;
    }
    .today-flag {
      background: #088531;
      color: #fff;
    }
    .selected-style {
      background: #00bdff;
      color: #ffffff;
    }

    .cbto {
      padding: 5px 0px;
      text-align: center;
      width: 100%;
      margin: auto;
      margin-top: 5px;
    }
    .cbto p {
      color: rgb(130, 215, 70);
    }

    .ci {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      vertical-align: middle;
    }
    .ct {
      display: inline-block;
      font-size: 12px;
      vertical-align: middle;
    }
    .down{
      *{
        transform: rotate(45deg);
        vertical-align: sub;
        color: #0bfcd7;
      }
    }
    .up{
      *{
        transform: rotate(45deg);
        vertical-align: sub;
        color: #0bfcd7;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/calender.vue